import React from "react";
import cx from "classnames";

import Body from "./DialogBody";
import Footer from "./DialogFooter";
import Header from "./DialogHeader";
import Title from "./DialogTitle";

class Dialog extends React.Component {
  static defaultProps = {
    baseClassName: "si-c-dialog",
  };

  render() {
    const { id, baseClassName, className, contentClassName, style, children, size, ...props } =
      this.props;

    const sizeClass = size ? baseClassName + "--" + size : "";

    return (
      <div
        tabIndex="-1"
        role="document"
        id={id}
        className={cx(baseClassName, className, sizeClass)}
      >
        <div className={cx("si-c-dialog__content", contentClassName)} style={style}>
          {children}
        </div>
      </div>
    );
  }
}

Dialog.Body = Body;
Dialog.Header = Header;
Dialog.Footer = Footer;
Dialog.Title = Title;

export default Dialog;
